import React, { useState } from 'react';
import './testimonials.css';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import QuoteIcon from '@mui/icons-material/FormatQuote';
import PersonIcon from '@mui/icons-material/Person';
import SwipeIcon from '@mui/icons-material/Swipe';
import './defects.css';
import { testimonialsData } from '../../data/testimonialsData';

const Testimonials = () => {
    const { header, scrollHint, testimonials } = testimonialsData;

    const [expandedReviews, setExpandedReviews] = useState({});

    const toggleExpand = (index) => {
        setExpandedReviews(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

    const renderFeedback = (feedback, index) => {
        const words = feedback.split(' ');
        const isExpanded = expandedReviews[index];
        if (words.length <= 50) {
            return feedback;
        }

        if (isExpanded) {
            return (
                <>
                    {feedback}
                    <span className="toggle-link" onClick={() => toggleExpand(index)}> Show less</span>
                </>
            );
        }

        const truncatedFeedback = words.slice(0, 50).join(' ') + '...';
        return (
            <>
                {truncatedFeedback}
                <span className="toggle-link" onClick={() => toggleExpand(index)}> Show more</span>
            </>
        );
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <StarIcon 
                key={index} 
                className={`star-icon ${index < rating ? 'filled' : 'empty'}`}
            />
        ));
    };

    return (
        <div className="testimonials-section">
            <div className="testimonials-container">
                <div className="testimonials-header">
                    <div className="testimonials-badge">
                        <QuoteIcon className="badge-icon" />
                        <span>{header.badge.text}</span>
                    </div>
                    <h1 className="testimonials-title">{header.title}</h1>
                    <p className="testimonials-description">
                        {header.description}
                    </p>
                </div>

                {/* Scroll Hint */}
                <div className="testimonials-scroll-hint">
                    <SwipeIcon className="scroll-hint-icon" />
                    <span>{scrollHint.text}</span>
                </div>

                <div className="testimonials-grid">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-card-header">
                                <div className="quote-icon">
                                    <QuoteIcon className="quote-svg" />
                                </div>
                                <div className="rating">
                                    {renderStars(testimonial.rating)}
                                </div>
                            </div>
                            
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    {renderFeedback(testimonial.feedback, index)}
                                </p>
                            </div>

                            <div className="testimonial-footer">
                                <div className="client-info">
                                    <div className="client-avatar">
                                        <PersonIcon className="avatar-icon" />
                                    </div>
                                    <div className="client-details">
                                        <h4 className="client-name">{testimonial.name}</h4>
                                        <p className="client-location">{testimonial.location}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
